<div class="modal-header">
  <h6 class="modal-title">
    Select a Course

    <!-- Info Icon with Tooltip -->
    <i
      class="fa fa-info-circle ms-2"
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      title="To list the exam agencies,and its courses available, Add exam agencies and its courses by
          Courses -> Exam Agencies -> Add Exam Agency"
      style="cursor: pointer;"
    ></i>
  </h6>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>

<div class="modal-body">

  <form [formGroup]="selectionForm">
    <!-- Exam Agency -->
    <div class="form-group row mb-1 align-items-center">
      <label for="examAgencySelect" class="col-sm-3 col-form-label text-end">
        Exam Agency
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="examAgencySelect"
          formControlName="examAgency"
          (change)="getCourses($event)"
        >
          <option *ngFor="let agency of examAgencies" [value]="agency.Code">
            {{ agency.Name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Course -->
    <div class="form-group row mb-1 align-items-center">
      <label for="courseSelect" class="col-sm-3 col-form-label text-end">
        Course
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="courseSelect"
          formControlName="course"
          (change)="getYears($event)"
        >

          <option *ngFor="let course of courses" [value]="course.Code">
            {{ course.Name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Year -->
    <div class="form-group row mb-1 align-items-center">
      <label for="yearSelect" class="col-sm-3 col-form-label text-end">
        Year
      </label>
      <div class="col-sm-9">
        <select class="form-select" id="yearSelect" formControlName="year" (change)="getCourseSubject($event)">
          <option *ngFor="let year of years" [value]="year.Code">
            {{ year?.Name }}
          </option>
        </select>
      </div>
    </div>
  </form>
  <div *ngIf="showAlert" class="d-flex justify-content-center ">
    <small class="text-danger">
      Subjects for this course are yet to be added. Go to Course Management Course > Course Subject screen and select the subjects relevant to this course
    </small>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-sm bl-btn"
    [disabled]="selectbutton && courseCategory"
    (click)=" goToNextRoute();"
  >
    Select
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border"
    (click)="activeModal.dismiss('Cross click')"
  >
    Cancel
  </button>
</div>
